import RW from "./class-RW.js";


function init_RW(){
	/*
		*	Set the core properties.
	*/
	RW.elements.widget 	= document.querySelector('.rw');
	RW.elements.image 	= document.querySelector('.rw-image');
	RW.elements.content = document.querySelector('.rw-content');
		RW.elements.title 	= document.querySelector('.rw-title');
		RW.elements.description 	= document.querySelector('.rw-description');
		RW.elements.date 	= document.querySelector('.rw-date');

	RW.nav.btnNext 		= document.querySelector('.rw-btn-next');
	RW.nav.btnPrev 		= document.querySelector('.rw-btn-prev');
	RW.nav.items 		= document.querySelectorAll('.rw-page-item');
	RW.nav.activeItem 	= document.querySelector('.rw-page-item--active');
	RW.nav.pageId 		= 0;

	/*
		*	JSON parse stage.
	*/
	RW.data = JSON.parse(RW.elements.widget.getAttribute('data-rw')).rws;

	/*
		*	Parse and create images.
	*/
	for(let i=0; i < RW.data.length; i++){
		// console.log(RW.data[i].image);

		/*
			*	Create IMGElement for each image data.
		*/
		let imageElement = new Image();
			imageElement.setAttribute('data-image-id', i);
			imageElement.addEventListener('load', RW.handler_ImageOnload);
		RW.imageEls.push({
			element: imageElement,
			loaded: false
		});
		RW.imageEls[i].element.src = RW.data[i].image;
	}

	/*
		*	Assign event listeners to the navigation buttons.
	*/
	RW.nav.btnPrev.addEventListener('click', RW.handler_Prev);
	RW.nav.btnNext.addEventListener('click', RW.handler_Next);

	/*
		*	Update the page content for the first data.
	*/
	RW.updateSlider(RW.nav.pageId);
}
document.addEventListener('DOMContentLoaded', init_RW);